webpackJsonp([159909797682334],{

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _logo_neue = __webpack_require__(96);
	
	var _logo_neue2 = _interopRequireDefault(_logo_neue);
	
	var _semanticUiReact = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SiteFooter = function (_React$Component) {
	    _inherits(SiteFooter, _React$Component);
	
	    function SiteFooter() {
	        _classCallCheck(this, SiteFooter);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    SiteFooter.prototype.render = function render() {
	        return _react2.default.createElement(
	            _semanticUiReact.Segment,
	            { basic: true, padded: 'very', inverted: true, className: 'footer', style: { 'marginTop': 0, 'backgroundColor': '#212121' } },
	            _react2.default.createElement(
	                _semanticUiReact.Container,
	                { textAlign: 'center' },
	                _react2.default.createElement(_semanticUiReact.Image, { centered: true, height: '60px', src: _logo_neue2.default }),
	                _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	                _react2.default.createElement(
	                    _semanticUiReact.List,
	                    { horizontal: true, inverted: true, padded: true },
	                    _react2.default.createElement(
	                        _semanticUiReact.List.Item,
	                        { name: 'About', href: '/about/' },
	                        'About'
	                    ),
	                    _react2.default.createElement(
	                        _semanticUiReact.List.Item,
	                        { name: 'Projects', href: '/projects/' },
	                        'Projects'
	                    ),
	                    _react2.default.createElement(
	                        _semanticUiReact.List.Item,
	                        { name: 'Reading', href: '/reading/' },
	                        'Reading'
	                    ),
	                    _react2.default.createElement(
	                        _semanticUiReact.List.Item,
	                        { name: 'Consulting', href: '/consulting/' },
	                        'Consulting'
	                    ),
	                    _react2.default.createElement(
	                        _semanticUiReact.List.Item,
	                        { name: 'Contact', href: '/contact/' },
	                        'Contact'
	                    )
	                ),
	                _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '\xA9 David Petrie 2018'
	                )
	            )
	        );
	    };
	
	    return SiteFooter;
	}(_react2.default.Component);
	
	exports.default = SiteFooter;
	module.exports = exports['default'];

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(14);
	
	var _logo_neue = __webpack_require__(97);
	
	var _logo_neue2 = _interopRequireDefault(_logo_neue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SiteHeader = function (_React$Component) {
	    _inherits(SiteHeader, _React$Component);
	
	    function SiteHeader(props) {
	        _classCallCheck(this, SiteHeader);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            cartCount: 0
	        };
	        return _this;
	    }
	
	    SiteHeader.prototype.componentDidMount = function componentDidMount() {};
	
	    SiteHeader.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { style: { 'backgroundColor': '#212121', 'padding-top': '15px', 'padding-bottom': '15px' } },
	            _react2.default.createElement(
	                _semanticUiReact.Container,
	                { fluid: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Container,
	                    null,
	                    _react2.default.createElement(
	                        _semanticUiReact.Menu,
	                        { inverted: true, secondary: true, stackable: true },
	                        _react2.default.createElement(
	                            _semanticUiReact.Menu.Item,
	                            { href: '/' },
	                            _react2.default.createElement(_semanticUiReact.Image, { centered: true, height: '40px', src: _logo_neue2.default })
	                        ),
	                        _react2.default.createElement(
	                            _semanticUiReact.Menu.Menu,
	                            { inverted: true, secondary: true, position: 'right' },
	                            _react2.default.createElement(_semanticUiReact.Menu.Item, { name: 'About', href: '/about/' }),
	                            _react2.default.createElement(_semanticUiReact.Menu.Item, { name: 'Projects', href: '/projects/' }),
	                            _react2.default.createElement(_semanticUiReact.Menu.Item, { name: 'Reading', href: '/reading/' }),
	                            _react2.default.createElement(_semanticUiReact.Menu.Item, { name: 'Consulting', href: '/consulting/' }),
	                            _react2.default.createElement(_semanticUiReact.Menu.Item, { name: 'Contact', href: '/contact/' }),
	                            _react2.default.createElement(_semanticUiReact.Menu.Item, { icon: 'twitter', href: 'https://www.twitter.com/davidcpetrie' }),
	                            _react2.default.createElement(_semanticUiReact.Menu.Item, { icon: 'github', href: 'https://github.com/cdave1' })
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return SiteHeader;
	}(_react2.default.Component);
	
	exports.default = SiteHeader;
	module.exports = exports['default'];

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(14);
	
	var _Header = __webpack_require__(81);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(80);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageWrapper = function (_React$Component) {
	    _inherits(PageWrapper, _React$Component);
	
	    function PageWrapper() {
	        _classCallCheck(this, PageWrapper);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this));
	    }
	
	    PageWrapper.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Header2.default, null),
	            _react2.default.createElement(
	                _semanticUiReact.Container,
	                null,
	                this.props.children
	            ),
	            _react2.default.createElement(_Footer2.default, null)
	        );
	    };
	
	    return PageWrapper;
	}(_react2.default.Component);
	
	exports.default = PageWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 666:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(38);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Wrapper = __webpack_require__(287);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _semanticUiReact = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogPostTemplate = function (_React$Component) {
	  _inherits(BlogPostTemplate, _React$Component);
	
	  function BlogPostTemplate() {
	    _classCallCheck(this, BlogPostTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BlogPostTemplate.prototype.render = function render() {
	    var post = this.props.data.markdownRemark;
	    var siteTitle = (0, _get2.default)(this.props, 'data.site.siteMetadata.title');
	
	    return _react2.default.createElement(
	      _Wrapper2.default,
	      { title: post.frontmatter.title + ' | ' + siteTitle },
	      _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { basic: true },
	        _react2.default.createElement('div', { className: 'blogText', dangerouslySetInnerHTML: { __html: post.html } }),
	        _react2.default.createElement(_semanticUiReact.Divider, null),
	        _react2.default.createElement(
	          _semanticUiReact.Label,
	          null,
	          post.frontmatter.date
	        )
	      )
	    );
	  };
	
	  return BlogPostTemplate;
	}(_react2.default.Component);
	
	exports.default = BlogPostTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-default-js-84230a7d2edc1bf4a9a4.js